import { render, staticRenderFns } from "./HelpWidget.vue?vue&type=template&id=be2955f0&scoped=true"
import script from "./HelpWidget.vue?vue&type=script&lang=js"
export * from "./HelpWidget.vue?vue&type=script&lang=js"
import style0 from "./HelpWidget.vue?vue&type=style&index=0&id=be2955f0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be2955f0",
  null
  
)

export default component.exports